/**
 * 动态配置管理工具
 * 自动获取前端IP地址和端口，构建API基础URL
 */

// 默认后端端口（作为fallback）
const DEFAULT_API_PORT = 8000;

/**
 * 获取当前页面的IP地址
 * @returns {string} 当前页面的IP地址
 */
const getCurrentIP = () => {
  // 从当前页面的location获取hostname
  const hostname = window.location.hostname;
  
  // 如果是localhost，使用127.0.0.1
  if (hostname === 'localhost') {
    return '127.0.0.1';
  }
  
  return hostname;
};

/**
 * 获取当前页面的端口
 * @returns {number} 当前页面的端口号
 */
const getCurrentPort = () => {
  // 获取当前页面的端口
  const port = window.location.port;
  
  // 如果没有端口（比如80或443），返回null表示使用默认端口
  if (!port) {
    return null;
  }
  
  return parseInt(port, 10);
};

/**
 * 获取API基础URL
 * @param {number} port API端口号，如果不提供则使用当前前端的端口
 * @returns {string} 完整的API基础URL
 */
export const getApiBaseUrl = (port = null) => {
  const ip = getCurrentIP();
  const currentPort = getCurrentPort();
  const apiPort = port || currentPort;
  
  // 如果是生产环境（非localhost），使用HTTPS协议
  const protocol = ip === 'localhost' || ip === '127.0.0.1' ? 'http' : 'https';
  
  // 如果是生产环境且没有指定端口，不添加端口号
  if (protocol === 'https' && !port && currentPort === null) {
    return `${protocol}://${ip}`;
  }
  
  // 如果是生产环境且端口是80或443，不添加端口号
  if (protocol === 'https' && (apiPort === 80 || apiPort === 443)) {
    return `${protocol}://${ip}`;
  }
  
  return `${protocol}://${ip}:${apiPort}`;
};

/**
 * 获取当前IP地址
 * @returns {string} 当前IP地址
 */
export const getCurrentIPAddress = () => {
  return getCurrentIP();
};

/**
 * 获取当前端口
 * @returns {number} 当前端口号
 */
export const getCurrentPortNumber = () => {
  return getCurrentPort();
};

/**
 * 获取默认API端口
 * @returns {number} 默认API端口
 */
export const getDefaultApiPort = () => {
  return DEFAULT_API_PORT;
};

// 导出默认配置
export default {
  getApiBaseUrl,
  getCurrentIPAddress,
  getCurrentPortNumber,
  getDefaultApiPort
}; 